import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { unitsApi as r } from "@maat/api-main";
//#region src/properties/useDeleteUnitMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteUnit(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.property() }), i.invalidateQueries({ queryKey: e.unit() }), i.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { i as useDeleteUnitMutation };
